// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1FW6l"};